import { Component, HostListener, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { DefaultLanguageId, Modalconfig, serverUrl } from "../../constants";
import { CommonHttpService } from "../../services/common-http/common-http.service";
import { PlaybookCommunicationService } from "projects/playbook-viewer/src/app/playbook-viewer/shared/services/playbook-communication.service";
import { RatingData, Resource } from "../../model/resource-model";
import { filter, some } from "lodash";
import { ResourceEmailComponent } from "../resource-email/resource-email.component";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ResourceFolders } from "../../model/container.models";
import { RatingsComponent } from "../ratings/ratings.component";
import { SessionStorageService } from "../../services/session-storage/session-storage.service";
import {
  profileRoles,
  sessionProfile,
} from "../../interfaces/sessionStorageModel";
import { UtilitiesService } from "../../services/utilities/utilities.service";
import { FolderDownloadService } from "../../services/folder-download/folder-download.service";
import { VideoAnalyticsService } from "../../services/video-analytics/video-analytics.service";
import { Location } from "@angular/common";
import { MessageService } from "../../services/message/message.service";

@Component({
    selector: "app-resourcelanding",
    templateUrl: "./resourcelanding.component.html",
    styleUrls: ["./resourcelanding.component.scss"],
    standalone: false
})
export class ResourcelandingComponent implements OnInit {
  routeSubscription: Subscription;
  resourceId: number;
  pageTemplateId;
  resource: any;
  resourceType: number;
  assetResourceId: number;
  languageId: number;
  assetId: number;
  folderId: number;
  playbookId: number;
  isOffline: boolean;
  resourcImageAllowedExtension: string[] = [".jpeg", ".jpg", ".png"];
  videoTypes: string[] = [".mp4", ".webm"];
  isAuthorize = true;
  isDownload = false;
  folderResources: Array<Resource> = [];
  defaultLanguageId = DefaultLanguageId;
  loggedInProfile: sessionProfile;
  companyId: number;
  pageId: number;
  serverUrl = serverUrl;
  videoClass = "mw-100 mh-100";
  isResource: boolean;
  pageFrom;
  private resEmailModalRef: BsModalRef;
  private bsResRatingsModal: BsModalRef;
  constructor(
    private router: Router,
    private messageService: MessageService,
    private location: Location,
    private utilitiesService: UtilitiesService,
    private activatedRoute: ActivatedRoute,
    private commonHttpService: CommonHttpService,
    private commService: PlaybookCommunicationService,
    private modalService: BsModalService,
    private sessionStorageService: SessionStorageService,
    private folderDownloadService: FolderDownloadService,
    private videoAnalyticsService: VideoAnalyticsService
  ) {}

  ngOnInit() {
    this.loggedInProfile =
      this.sessionStorageService.getLoggedInProfileDetail();
    this.isOffline = this.commService.IsOffline || typeof process === "object";
    this.languageId =
      +this.activatedRoute.snapshot.queryParams.languageId ||
      this.defaultLanguageId;
    this.resourceId = this.activatedRoute.snapshot.queryParams.resourceId || 0;
    this.assetResourceId = +this.activatedRoute.snapshot.params.assetId || 0;
    this.folderId = +this.activatedRoute.snapshot.queryParams.folderId || 0;
    this.playbookId = +this.activatedRoute.snapshot.queryParams.playbookId || 0;
    this.pageId = +this.activatedRoute.snapshot.queryParams.pageId || 0;
    this.companyId = +this.activatedRoute.snapshot.queryParams.companyId || 0;
    this.pageTemplateId =
      this.activatedRoute.snapshot.queryParams.pageTemplateId || null;
    this.pageFrom = +this.activatedRoute.snapshot.queryParams.pageFrom || null;
    if (this.resourceId) {
      this.getResource();
    } else if (this.assetResourceId) {
      this.getAsset();
    } else if (this.folderId) {
      this.getFolderAssets();
      this.saveFolderViewHit();
    }
  }
  saveFolderViewHit() {
    this.commonHttpService
      .post({
        uri: "/api/Resources/SaveFolderViewHit",
        object: {
          folderId: this.folderId,
          playbookId: this.playbookId,
          pageId: this.pageId,
        },
      })
      .subscribe();
  }

  getFolderAssets() {
    this.commonHttpService
      .get({
        uri: `/api/Resources/GetAllResourcesForFolder?playbookId=${this.playbookId}&folderId=${this.folderId}&languageId=${this.languageId}`,
      })
      .subscribe(
        (folderResources: any) => {
          this.folderResources = folderResources;
          this.isShowDownloadBtn(folderResources);
        },
        (error) => {
          if (error === "You are Unauthorized to access the data") {
            this.isAuthorize = false;
          }
        }
      );
  }

  getAsset() {
    this.commonHttpService
      .get({
        uri: `/api/Assets/GetAssetById?id=${this.assetResourceId}`,
      })
      .subscribe(
        (resource: any) => {
          this.interpretResponse(resource);
        },
        (error) => {
          if (error === "You are Unauthorized to access the data") {
            this.isAuthorize = false;
          }
        }
      );
  }

  getResource() {
    this.commonHttpService
      .get({
        uri: `/api/Resources/GetAssetByResourceId?id=${
          this.resourceId
        }&languageId=${
          this.languageId === DefaultLanguageId ? null : this.languageId
        }&pageTemplateId=${this.pageTemplateId}`,
      })
      .subscribe(
        (resource: any) => {
          this.interpretResponse(resource);
        },
        (error) => {
          if (error === "You are Unauthorized to access the data") {
            this.isAuthorize = false;
          }
        }
      );
  }
  submitAnalytics() {
    if (
      [
        profileRoles.administrator,
        profileRoles.salesManager,
        profileRoles.playbookOwner,
        profileRoles.user,
      ].includes(this.loggedInProfile.role)
    ) {
      this.saveVideoAnalytics(
        this.videoAnalyticsService.getVideoTrackingData(
          `content-video-${this.assetId}`
        )
      );
    }
  }

  @HostListener("window:beforeunload", ["$event"])
  logTime($event: any) {
    if (
      [
        profileRoles.administrator,
        profileRoles.salesManager,
        profileRoles.playbookOwner,
        profileRoles.user,
      ].includes(this.loggedInProfile.role)
    ) {
      this.saveVideoAnalytics(
        this.videoAnalyticsService.getVideoTrackingData(
          `content-video-${this.assetId}`
        )
      );
    }
    var start = new Date().getTime();
    while (new Date().getTime() < start + 1000);
  }

  interpretResponse(resource: any) {
    this.resource = resource;
    this.assetId = this.resource.assetId || this.resource.id;
    if (this.assetResourceId) {
      this.resource.filetype = this.resource.fileExtension;
    }
    if (this.resource.filetype) {
      if (
        this.resourcImageAllowedExtension.includes(
          this.resource.filetype.toLowerCase()
        )
      ) {
        this.resourceType = 1;
      } else if (
        this.videoTypes.includes(this.resource.filetype.toLowerCase())
      ) {
        this.resourceType = 2;
        setTimeout(() => {
          if (
            [
              profileRoles.administrator,
              profileRoles.salesManager,
              profileRoles.playbookOwner,
              profileRoles.user,
            ].includes(this.loggedInProfile.role)
          ) {
            this.videoAnalyticsService.trackVideo(
              `content-video-${this.assetId}`
            );
          }
        }, 200);
      } else {
        this.isDownload = true;
        this.downloadAsset(this.resource);
      }
    }
  }

  getAssets() {
    // check for embed
    // azure issue check
    return `/api/Assets/GetResourceById/${this.assetId}`;
  }

  downloadAsset(resource) {
    this.utilitiesService.getAssetAzureUrl(
      `/api/Assets/Resource/${this.assetId}`,
      { isShowErrorMessage: false }
    );
  }

  /**
   * To check asset condition in resources
   * Used in language resources to show conditional fields and also in original resources
   * @param resource resource object
   */
  checkResourceAssetCondition(resource: Resource) {
    let flag = false;
    if (resource) {
      if (
        resource.type === 1 &&
        resource.linkUrl !== undefined &&
        resource.linkUrl !== null &&
        resource.linkUrl.toString().trim() !== ""
      ) {
        flag = true;
      } else if (
        (resource.type === 2 || resource.type === 0) &&
        resource.asset !== undefined &&
        resource.asset !== null
      ) {
        flag = true;
      }
    }
    return flag;
  }

  /**
   * To open the resource on new page for download
   */
  openResource(resource: Resource) {
    return `${window.location.origin}/assets/download/${resource.assetId}${
      this.pageFrom ? "?pageFrom=" + this.pageFrom : ""
    }`;
  }

  /**
   * To open modal for email resource
   * @param selectedResource selected resource in case resource email icon clicked
   */
  openMailResourceModal(selectedResource: Resource, folderName?: string) {
    const langId = this.languageId || this.defaultLanguageId;
    this.commonHttpService
      .get({
        uri:
          "/api/Resources/GetPlaybooksAllResources?playbookId=" +
          this.playbookId +
          "&languageId=" +
          langId,
      })
      .subscribe((response: Array<Resource>) => {
        const resourceData = selectedResource
          ? filter(response, (eachResources) =>
              typeof selectedResource.type === "number"
                ? selectedResource.folderId === eachResources.folderId
                : selectedResource.id === eachResources.folderId
            )
          : response;
        const initialState = {
          resources: resourceData,
          selectedResource,
          sendMultiple: selectedResource && !folderName ? false : true,
          playbookId: this.playbookId,
          languageId: langId,
          folderName,
        };
        this.resEmailModalRef = this.modalService.show(
          ResourceEmailComponent,
          Object.assign(
            { initialState },
            { class: "custom-modal confirm-modal" },
            Modalconfig
          ) as any
        );
      });
  }

  /**
   * To open link of url resource type
   */
  openResourceUrl(resource: Resource) {
    window.open(resource.linkUrl, "_blank");
  }

  /**
   * @param resource resource object
   * To check if resource object contain resource link or not
   */
  checkResourceForNullAssets(resource: Resource & ResourceFolders) {
    if (resource) {
      if (
        (resource.type === 1 &&
          resource.linkUrl &&
          resource.linkUrl.toString().trim() !== "") ||
        ((resource.type === 2 || resource.type === 0) && resource.asset) ||
        (resource.resources && resource.resources.length)
      ) {
        return true;
      }
    }
    return false;
  }

  /**
   * To open resource ratings modal
   * @param resId resource id
   */
  openRatingsModal(resId, type = 1) {
    this.commonHttpService
      .post({
        uri: "/api/Ratings/GetAllRatings",
        object: {
          id: resId,
          type,
          playbookId: this.playbookId,
          languageId: this.languageId,
          profileId: this.loggedInProfile.id,
          companyId: this.companyId,
        },
      })
      .subscribe((response: RatingData) => {
        const initialState = {
          ratingsData: response,
          playbookId: this.playbookId,
          languageId: this.languageId,
          profileId: this.loggedInProfile.id,
          role: this.loggedInProfile.role,
          containerId: response.containerId,
          ...(type === 1 && { resourceId: resId }),
          ...(type === 2 && { folderId: resId }),
          companyId: this.companyId,
          type,
        };
        this.bsResRatingsModal = this.modalService.show(
          RatingsComponent,
          Object.assign(
            { initialState },
            { class: "custom-modal" },
            Modalconfig
          )
        );
      });
  }

  donwloadZipFile(downloadResponse) {
    const url = this.serverUrl + "/" + downloadResponse.replace(/\\/g, "/");
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = url.split("/").pop();
    anchor.target = "_self";
    anchor.click();
    anchor.remove();
  }

  downloadFolder(folderId) {
    this.folderDownloadService.getDownloadReportData(
      folderId,
      { playbookId: this.playbookId, id: this.pageId },
      this.languageId
    );
  }

  isShowDownloadBtn(folderResources) {
    this.isResource = some(
      folderResources,
      (eachResources) => eachResources.assetId
    );
  }

  saveVideoAnalytics(analyticsData) {
    if (analyticsData.totalTimeView) {
      const reqObj = {
        id: null,
        playbookId: null,
        pageId: null,
        sectionId: null,
        activityId: null,
        assetId: this.assetId,
        resourceId: this.resourceId,
        timeJson: JSON.stringify(analyticsData.timeArr),
        totalTime: analyticsData.totalTimeView,
        timeOnClose: analyticsData.videoTrackObj.currentTime,
        videoLength: analyticsData.totalVideoSize,
      };
      this.commonHttpService
        .post({
          uri: "/api/OnlineAnalytics/SaveVideoAnalytics",
          object: reqObj,
        })
        .subscribe((response) => {});
    }
  }

  copyResourceShareableLink(params: {
    resourceId?: number;
    companyId?: number;
    playbookId?: number;
    pageId?: number;
    folderId?: number;
    languageId?: number;
    pageTemplateId?: number;
    pageFrom?: number;
  }) {
    const url = new URL(
      `${window.location.protocol}${window.location.host}/home/resourcelanding`
    );

    if (params.resourceId) {
      url.searchParams.append("resourceId", `${params.resourceId}`);
    }
    if (params.companyId) {
      url.searchParams.append("companyId", `${params.companyId}`);
    }
    if (params.playbookId) {
      url.searchParams.append("playbookId", `${params.playbookId}`);
    }
    if (params.pageId) {
      url.searchParams.append("pageId", `${params.pageId}`);
    }
    if (params.folderId) {
      url.searchParams.append("folderId", `${params.folderId}`);
    }
    if (params.languageId) {
      url.searchParams.append("languageId", `${params.languageId}`);
    }
    if (params.pageTemplateId) {
      url.searchParams.append("pageTemplateId", `${params.pageTemplateId}`);
    }
    if (params.pageFrom) {
      url.searchParams.append("pageFrom", `${params.pageFrom}`);
    }

    if (window.navigator["clipboard"]) {
      window.navigator["clipboard"].writeText(url.toString());
    }
    this.messageService.showSuccessMessage(
      "Resource Shareable Link successfully copied to your clipboard."
    );
  }

  getBackUrl = () => this.activatedRoute.snapshot.queryParams["returnUrl"];
}
